/* tslint:disable */
/* eslint-disable */
/**
 * incidentsv2
 * incidentsv2
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IncidentProtocolResponsiblePartyListEntry
 */
export interface IncidentProtocolResponsiblePartyListEntry {
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolResponsiblePartyListEntry
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolResponsiblePartyListEntry
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof IncidentProtocolResponsiblePartyListEntry
     */
    name: string;
}

/**
 * Check if a given object implements the IncidentProtocolResponsiblePartyListEntry interface.
 */
export function instanceOfIncidentProtocolResponsiblePartyListEntry(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "name" in value;

    return isInstance;
}

export function IncidentProtocolResponsiblePartyListEntryFromJSON(json: any): IncidentProtocolResponsiblePartyListEntry {
    return IncidentProtocolResponsiblePartyListEntryFromJSONTyped(json, false);
}

export function IncidentProtocolResponsiblePartyListEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): IncidentProtocolResponsiblePartyListEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'name': json['name'],
    };
}

export function IncidentProtocolResponsiblePartyListEntryToJSON(value?: IncidentProtocolResponsiblePartyListEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'type': value.type,
        'name': value.name,
    };
}

